import Vue from 'vue';
import { HeadlineWithRelatedArticles } from '@headlines/types/headline';
import getItemFromObject from 'lodash/get';
import { SwiperOptions } from 'swiper/types/swiper-options';

type Settings<T> = T;
export default <T>(settings: Settings<T>) => {
  interface Methods {
    labels: (headline: HeadlineWithRelatedArticles, domain?: string) => (string | undefined)[];
  }

  interface Props {
    blockKey: string;
    data: {
      items: HeadlineWithRelatedArticles[];
    };
    settings: Settings<T>;
    hasChannelSubscription: boolean;
    index: number;
  }

  interface Computed {
    getSettings: Settings<T>;
    swiperOptions?: SwiperOptions | undefined;
  }

  return Vue.extend<unknown, Methods, Computed, Props>({
    props: {
      blockKey: {
        type: String,
        required: false,
        default: '',
      },
      data: {
        type: Object,
        required: true,
      },
      settings: {
        type: Object,
        required: true,
      },
      hasChannelSubscription: {
        type: Boolean,
        required: false,
        default: false,
      },
      index: {
        type: Number,
        required: false,
      },
    },
    computed: {
      getSettings() {
        return { ...settings, ...this.settings };
      },
    },
    methods: {
      labels(headline, domain = 'www.delfi.lt') {
        const labels = [];
        const sameChannel = domain === headline.primaryCategory?.channel.url;

        if (!sameChannel && headline.primaryCategory?.channel.url !== 'www.delfi.lt') {
          labels.push(getItemFromObject(headline, 'primaryCategory.channel.name'));
        } else {
          labels.push(getItemFromObject(headline, 'primaryCategory.name'));
        }

        return labels;
      },
    },
  });
};
